import React from "react";
import './HomeCategories.css';  // Optionally, for styling

export default function HomeCategories() {
    const categoryCard = [
        {
            id: 1,
            images: [
                { src: "/customisedprinting.jpg", heading: "Customised Printing Solutions", description: "We offer a diverse range of custom printing solutions tailored to your branding and marketing goals. From business cards and brochures to promotional materials, our services ensure precision and creativity for all your needs." },
            ],
        },
        {
            id: 2,
            images: [
                { src: "/premiumprint.jpg", heading: "Premium-Quality Materials", description: "Our prints use high-quality materials chosen for their durability and eco-friendliness. With options like recycled paper and premium textures, we ensure every product looks exceptional and stands the test of time." },
            ],
        },
        {
            id: 3,
            images: [
                { src: "/bulkprinting.jpg", heading: "Large-Scale Format Printing", description: "Our large-format printing is perfect for banners, posters, and signage and delivers high-resolution results in various sizes. We provide impactful solutions for your big ideas, whether for events, retail, or exhibitions." },
            ],
        },
        {
            id: 4,
            images: [
                { src: "/premiumpackages.jpg", heading: "Innovative Packaging Solutions", description: "We specialise in custom packaging printing, including boxes, labels, and wraps highlighting your products. Our designs ensure packaging that’s both functional and visually appealing, elevating your brand’s identity." },
            ],
        },
        {
            id: 5,
            images: [
                { src: "/businesscutom.jpg", heading: "Personalised Business Stationery", description: " Our personalised stationery printing includes letterheads, notepads, and envelopes tailored to your brand. These solutions are designed for professionalism and usability and suit corporate and personal requirements." },
            ],
        },
        {
            id: 6,
            images: [
                { src: "/promo.jpg", heading: "Creative Promotional Materials", description: "We design custom promotional printing that captures your audience’s attention. From flyers and postcards to branded merchandise, our materials effectively spread your message across diverse channels." },
            ],
        }
     
    ];

    return (
        <div className="container mt-45">
            <h2 className="text-center home-cat-heading">Printing Categories We Cover</h2>
            <div className="row">
                {categoryCard.map((card) => (
                    <div key={card.id} className="col-md-4">
                        <div className=" cat-outer-div">
                           <div className=" category-card">
                             {/* Displaying only the first image in the images array */}
                             <div className="cat-image-item">
                             <h5 className="cat-inner-hed">{card.images[0].heading}</h5>
                                <img src={card.images[0].src} alt={card.images[0].heading} className="img-fluid" />
                               
                                <p className="cat-inner-para">{card.images[0].description}</p>
                            </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className=" other-contin">
                <div className="other-cont row ">
                <div className="col-md-6">
                    <div className="solutions-cont">
                    <h2 className="cutomh2">Tailored Printing Services for Every Industry</h2>
                    <h3 className="cutomh3">We provide custom printing solutions for retail, hospitality, education, and more. Let us help you achieve your branding and marketing goals.</h3>
                    </div>
                  </div>
                  <div className="col-md-6">
                  <div className="solutions-cont">
                  <h2 className="cutomh2">Premium Materials for Exceptional Results</h2>
                  <h3 className="cutomh3">Our high-quality materials, from eco-friendly options to premium textures, ensure durable and visually stunning printed products every time.</h3>
                  </div>
                    </div>
                    <div className="col-md-6">
                    <div className="solutions-cont">
                    <h2 className="cutomh2">Creative Promotional and Packaging Solutions</h2>
                    <h3 className="cutomh3">Engage your audience with creative promotional items and premium packaging. We design to elevate your brand and leave a lasting impression.</h3>
                    </div>
                  </div>
                  <div className="col-md-6">
                 <div className="solutions-cont">
                 <h2 className="cutomh2">Reliable Large Format Printing Services</h2>
                 <h3 className="cutomh3">Whether for banners, posters, or signage, our large format prints deliver high-definition quality to make a big impact in any setting.</h3>
                 </div>
                    </div>
                </div>
                </div>
        </div>
    );
}
